/** 빌드 레벨에서 제거되는 컴포넌트의 stub */
const Empty = () => null;
export default Empty;
